import { NeedToKnowVisibilityLevel } from './need-to-know-visibility-level.enum';

export const NEED_TO_KNOW_VISIBILITY_LEVEL_LOOKUP = [
  { value: NeedToKnowVisibilityLevel.AllianceGroupLevel, description: 'Alliance Group' },
];
